export default {
  summary_one: '{{count}} item was removed · not available for your pickup time',
  summary_other: '{{count}} items were removed · not available for your pickup time',
  reason: 'Only orderable {{schedule}} — your pickup is at {{time}}.',
  change_pickup_time: 'Change pickup time',
  dismiss: 'Dismiss',
};
